/**
 * Image Optimization Utilities
 * Helpers for lazy loading and responsive images
 */

/**
 * Get lazy loading props for images
 * @returns {Object} Props to spread on img tags
 */
export const getLazyLoadProps = () => ({
  loading: "lazy",
  decoding: "async",
});

/**
 * Get optimized image props with lazy loading
 * @param {string} alt - Alt text for the image
 * @param {boolean} eager - Whether to load eagerly (for above-the-fold images)
 * @returns {Object} Props to spread on img tags
 */
export const getOptimizedImageProps = (alt, eager = false) => ({
  alt: alt || "",
  loading: eager ? "eager" : "lazy",
  decoding: eager ? "sync" : "async",
});

/**
 * Check if WebP is supported
 * @returns {boolean}
 */
export const isWebPSupported = () => {
  const elem = document.createElement("canvas");
  if (elem.getContext && elem.getContext("2d")) {
    return elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
  }
  return false;
};

/**
 * Get responsive image sizes attribute
 * @param {Object} breakpoints - Object with breakpoint sizes
 * @returns {string} Sizes attribute value
 */
export const getResponsiveSizes = (breakpoints = {}) => {
  const defaults = {
    xs: "100vw",
    sm: "100vw",
    md: "50vw",
    lg: "33vw",
  };
  const sizes = { ...defaults, ...breakpoints };
  return `(max-width: 600px) ${sizes.xs}, (max-width: 960px) ${sizes.sm}, (max-width: 1280px) ${sizes.md}, ${sizes.lg}`;
};

export default {
  getLazyLoadProps,
  getOptimizedImageProps,
  isWebPSupported,
  getResponsiveSizes,
};

